import DesktopHeader from './DesktopHeader'
import MobileHeaderAlt from './MobileHeaderAlt'


export default class HeaderController {
    constructor() {
        this.desktop = new DesktopHeader()
        this.mobile = new MobileHeaderAlt()
        this.regionPicker = $('#region-picker')

        this.adapt()
        $(window).on('load resize orientationchange', () => this.adapt())
    }

    isDesktop() {
        return this.desktop.active
    }

    isMobile() {
        return this.mobile.active
    }

    adapt() {
        let dtFocus = this.desktop.search.input.is(':focus'),
            mbFocus = this.mobile.search.input.is(':focus')

        if (window.innerWidth <= 767) {
            this.desktop.detach()
            this.mobile.attach()
            // this.mobile.regionSection.append(this.regionPicker)
        } else {
            this.mobile.detach()
            this.desktop.attach()
            $(document.body).append(this.regionPicker)
            $(document.body).trigger('regionPicker/hide')
        }


        if (dtFocus) {
            this.desktop.search.input.trigger('focus')
        }
        if (mbFocus) {
            this.mobile.search.input.trigger('focus')
        }
    }
}
